import { Component, OnInit, inject, signal } from '@angular/core';
import { ParameterService, PaymentService } from '@frontend/frontendlib';


@Component({
  selector: 'app-dopayment',
  templateUrl: './dopayment.component.html',
  styleUrls: ['./dopayment.component.css'],
})
export class DopaymentComponent implements OnInit {
  link = signal('');
  type = signal(0);
  data = signal({});
  loading = signal(false);
  
  private paymentService = inject(PaymentService);
  private parameterService = inject(ParameterService);
  public choosedPaymentprovider = this.parameterService.choosedPaymentprovider;
  public showAmazon = signal(false);
  public showGoogePayOverPaypal = signal(false);
  public showApplePayOverPaypal = signal(false);

  ngOnInit(): void {
    this.chooseProviderToApi();
  }

  chooseProviderToApi(): void {
    this.loading.set(true);

    this.paymentService
      .chooseProvider(
        this.parameterService.queryParams.channel_id,
        this.parameterService.queryParams.payment_id ?? '',
        this.parameterService.queryParams.paymentprovider_id ?? ''
      )
      .subscribe((data) => {
        const resp = data['data'];
        this.link.set(resp['response_url'] ?? '');
        this.type.set(resp['response_type'] ? resp['response_type'] * 1 : 0);
        this.data.set(resp['data'] ?? ({} as any));
        this.showAmazon.set(this.parameterService.isAmazon());
        this.showGoogePayOverPaypal.set(this.parameterService.isGooglepayOverPaypal());
        this.showApplePayOverPaypal.set(this.parameterService.isApplePayOverPaypal());
        this.loading.set(false);
        this.handleResponse();
      });
  }

  handleResponse(): void {
    if (this.type() * 1 === 1) {
      setTimeout(() => {
        if (!this.showAmazon() && !this.showGoogePayOverPaypal() && !this.showApplePayOverPaypal()) {
          window.location.assign(this.link());
        }
      }, 5000);
    } else {
      this.parameterService.runGoogleTag('purchase');
    }
  }
}
